import { createAction, props } from '@ngrx/store';
import {Submenu} from '@emm/core/models/submenu.model';

export enum SubmenusAction {
    Load = '[Submenu List] Load Submenus',
    LoadSuccess = '[Submenu List] Load Submenus Success',
    LoadFailure = '[Submenu List] Load Submenus Failure',

    FilterSubmenus ='[Submenus List] Filter Submenus Success',

    Select = '[Submenu List] Select Submenu',
    Deselect = '[Submenu List] Deselect Submenu',
    SelectSearchSubmenu = '[Submenu List] Select Search Submenu',
    DeselectSearchSubmenu = '[Submenu List] Deselect Search Submenu',

    SaveAssignments = '[Submenu Assignments] Save Assignments',
    SaveAssignmentsSuccess = '[Submenu Assignments] Save Assignments Success',
    SaveAssignmentsFailure = '[Submenu Assignments] Save Assignments Failure',

    Add = '[Submenu List] Add Submenu',
    AddFailure = '[Submenu List] Add Submenu Failure',
    AddSuccess = '[Submenu List] Add Submenu Success'
}

export const SubmenusActions = {
    load: createAction(SubmenusAction.Load),
    loadSuccess: createAction(SubmenusAction.LoadSuccess, props<{ submenus: Submenu[] }>()),
    loadFailure: createAction(SubmenusAction.LoadFailure, props<{ error: any }>()),

    filterSubmenus: createAction(SubmenusAction.LoadSuccess, props<{ submenus: Submenu[] }>()),

    select: createAction(SubmenusAction.Select, props<{ tag: string }>()),
    deselect: createAction(SubmenusAction.Deselect, props<{ tag: string }>()),
    selectSearchSubmenu: createAction(SubmenusAction.SelectSearchSubmenu, props<{ tag: string }>()),
    deselectSearchSubmenu: createAction(SubmenusAction.DeselectSearchSubmenu),

    saveAssignments: createAction(SubmenusAction.SaveAssignments, props<{ assignments: any[] }>()),
    saveAssignmentsSuccess: createAction(SubmenusAction.SaveAssignmentsSuccess, props<{ response: any[] }>()),
    saveAssignmentsFailure: createAction(SubmenusAction.SaveAssignmentsFailure, props<{ error: any }>()),

    add: createAction(SubmenusAction.Add, props<{ submenu: any }>()),
    addSuccess: createAction(SubmenusAction.AddSuccess),
    addFailure: createAction(SubmenusAction.AddFailure, props<{ error: any }>()),
};

export const AsyncActions = {
   loadActions: [SubmenusActions.load],
   successActions: [SubmenusActions.loadSuccess],
   errorActions: [SubmenusActions.loadFailure]
};
